// Imperium Core — Obsidian + Gold Design Tokens
export const OBSIDIAN = '#05050A';
export const GOLD = '#D4AF37';
export const GOLD_40 = 'rgba(212,175,55,0.4)';
export const GOLD_20 = 'rgba(212,175,55,0.2)';
export const GOLD_10 = 'rgba(212,175,55,0.1)';
export const SAPPHIRE_50 = 'rgba(15,82,186,0.5)';

// Empire tab icon — Golden Diamond Seal
export const EMPIRE_ICON = { src: '/icons/empire_seal.png', pos: '50% 50%' };
export const TRY_ICON = { src: '/icons/golden_egg.png', pos: '50% 40%' };

// Animal icons for bottom nav — objectPosition controls framing in circles
export const ANIMAL_ICONS = {
  fashion:  { src: '/icons/leopard_v2.png',  pos: '50% 25%' },
  food:     { src: '/icons/gazelle.png',     pos: '50% 30%' },
  explore:  { src: '/icons/falcon_v2.png',   pos: '50% 25%' },
  souls:    { src: '/icons/phoenix_v2.png',  pos: '50% 30%' },
  sporty:   { src: '/icons/gorilla_v2.png',  pos: '50% 30%' },
  success:  { src: '/icons/stallion_v2.png', pos: '50% 20%' },
  legacy:   { src: '/icons/lion_legacy.png', pos: '50% 25%' },
  art:      { src: '/icons/crystal_crane.png', pos: '50% 35%' },
  dragon:   { src: '/icons/empire_seal.png',  pos: '50% 50%' },
  fox:      { src: '/society/fox.jpg',        pos: '50% 35%' },
  panther:  { src: '/society/panther.jpg',    pos: '50% 35%' },
  peacock:  { src: '/society/peacock.jpg',    pos: '50% 40%' },
};

// Full-body running/flying beast silhouettes for the upload progress bar
// Compressed JPEGs (~10-13KB each) for instant mobile loading
export const BEAST_SILHOUETTES = {
  fashion:  '/icons/run_leopard.jpg',
  food:     '/icons/run_gazelle.jpg',
  explore:  '/icons/run_falcon.jpg',
  souls:    '/icons/run_phoenix.jpg',
  sporty:   '/icons/run_gorilla.jpg',
  success:  '/icons/run_stallion.jpg',
  legacy:   '/icons/run_lion.jpg',
  art:      '/icons/crystal_crane.png',
};
